module.exports = __webpack_public_path__ + "img/Vector-bottom.6cc4bc57.svg";